var styles = {"segmentInput":"styles_segment-input__wHVRS","list":"styles_list__JxdrB","segment":"styles_segment__asaGJ"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
